import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CrudService {
  baseUrl: string = environment.API_URL;

  constructor(private http: HttpClient) {}

  fetchData(url: any): Observable<any[]> {
    let final_url = this.baseUrl + url;
    return this.http.get<any[]>(final_url);
  }

  postData(url: any, newData: any): Observable<any> {
    let final_url = this.baseUrl + url;
    return this.http.post<any[]>(final_url, newData);
  }

  putData(url: any, updatedData: any): Observable<any> {
    let final_url = this.baseUrl + url;
    return this.http.put<any[]>(final_url, updatedData);
  }

  patchData(url: any, updatedData: any): Observable<any> {
    let final_url = this.baseUrl + url;
    return this.http.patch<any[]>(final_url, updatedData);
  }

  addData(url: any, newData: any): Observable<any[]> {
    return this.http.post<any[]>(url, newData);
  }

  updateData(url: any, updatedData: any): Observable<any[]> {
    return this.http.put<any[]>(url, updatedData);
  }

  deleteData(url: any): Observable<any> {
    let final_url = this.baseUrl + url;
    return this.http.delete<any>(final_url);
  }

  getData(url: any): Observable<any> {
    let final_url = this.baseUrl + url;
    return this.http.get<any>(final_url);
  }

  postFormData(url: string, formData: FormData): Observable<any> {
    let final_url = this.baseUrl + url;
    return this.http.post<any>(final_url, formData);
  }

  downloadSubscribersCSV(): Observable<Blob> {
    let final_url = this.baseUrl + 'Admin/DownloadSubscribersExcel';
    return this.http.get(final_url, { responseType: 'blob' });
  }
}
